module.exports = __webpack_public_path__ + "portal-static/img/logo.46a97362.png";